(angular => {
  "use strict";

  angular.module("App").component("selectEventComponent", {
    template: `
      <div>
        <md-input-container class="md-block">
          <label>Eventos</label>
          <md-select ng-model="$ctrl.selectedEvent" ng-change="$ctrl.change()" placeholder="Evento">
            <md-option ng-repeat="event in $ctrl.events" ng-value="event.id">{{event.title}}</md-option>
          </md-select>
        </md-input-container>
      </div>
    `,
    controller: [
      "$route",
      "$window",
      "Loader",
      "EventService",
      "AuthService",
      "LoginService",
      SelectEventCtrl
    ]
  });

  function SelectEventCtrl($route, $window, Loader, eventService, authService, loginService) {
    const user = authService.getTokenData();
    this.selectedEvent = user.eventId;

    if (user.preview) return;

    eventService.list().then(events => {
      this.events = events;
    });

    this.change = () => {
      Loader.add(loginService.changeEvent(this.selectedEvent)).then(() => {
        $window.location.reload();
      });
    };

  }

})(angular);
